import * as React from 'react';
import styled from 'styled-components';

const HiddenLabel = styled.div`
  position: absolute;
  max-width: 1000px;
  overflow-x: hidden;
  left: -9999px;
`;

export interface IOptionLabelProps {
  hideLabel?: boolean;
  children?: React.ReactNode;
}

/**
 * Renderizza la label dell'opzione nascosta
 * ma presente per l'accesibilità (se necessario)
 */
export function OptionLabel(props: IOptionLabelProps) {
  return props.hideLabel ? (
    <HiddenLabel>{props.children}</HiddenLabel>
  ) : (
    <>{props.children}</>
  );
}
